import { createContext, useContext } from 'react'

export type Locale = 'en' | 'hu'

export const DEFAULT_LOCALE: Locale = 'en'
export const LOCALE_STORAGE_KEY = 'garlictech-locale'

export const isLocale = (value: unknown): value is Locale => value === 'en' || value === 'hu'

export interface LocaleContextValue {
  locale: Locale
  setLocale: (locale: Locale) => void
}

export const LocaleContext = createContext<LocaleContextValue | null>(null)

export const useLocale = (): LocaleContextValue => {
  const context = useContext(LocaleContext)
  if (!context) throw new Error('useLocale must be used within LocaleProvider')
  return context
}
